import { lazyWithRetry } from 'utils/lazyWithRetry';

export const LazyRichText = lazyWithRetry(() => import('./RichText').then((module) => ({ default: module.RichText })));

export type { RichTextProps } from './RichText';
